// extracted by mini-css-extract-plugin
module.exports = {"text":"styles_text__uual2","chevron":"styles_chevron__YsHO9","skeleton-animation":"styles_skeleton-animation__yRlzN","container":"styles_container__ILUsY"};